export const getSalonAccess = (access, salonId) =>
  (access?.salons || []).find((salon) => Number(salon.salon_id) === Number(salonId));

export const hasSalonPermission = (access, salonId, code) => {
  const salon = getSalonAccess(access, salonId);
  return Boolean(salon && (salon.is_owner || salon.permission_codes?.includes(code)));
};

export const canSeeDomain = (access, code) =>
  (access?.salons || []).some(
    (salon) => salon.is_owner || salon.permission_codes?.includes(code),
  );
